import {AsyncAction} from 'overmind'
import i from 'i18next'

export const getTaskSettings: AsyncAction<void> = async ({state, effects}) => {
  console.log('FETCH NEW TASK SETTINGS')
  state.v1.settings.tasks.pending = true
  state.v1.settings.tasks.data = {}
  state.v1.settings.tasks.error = null
  try {
    const settings = await effects.v1.settings.tasks.getTaskSettings()
    state.v1.settings.tasks.data = settings
  } catch (err) {
    state.v1.settings.tasks.error = err as Error
  } finally {
    state.v1.settings.tasks.pending = false
  }
}

export const exportTaskSettings: AsyncAction<any> = async ({state, effects}, filters) => {
  state.v1.settings.tasks.exportPending = true
  try {
    const response = await effects.v1.settings.tasks.exportTaskSettings(filters)
    if (!response || !response.body) return

    const base64File = response.body
    const binaryData = atob(base64File)

    const byteArray = new Uint8Array(binaryData.length)
    for (let i = 0; i < binaryData.length; i++) {
      byteArray[i] = binaryData.charCodeAt(i)
    }
    const blob = new Blob([byteArray], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    const filename = i.t('tasks:labels.exportFilename', 'task_list.xlsx')
    link.download = filename
    link.click()
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error exporting task list:', error)
    throw error
  } finally {
    state.v1.settings.tasks.exportPending = false
  }
}
